import { CART_ACTION_TYPES } from "./actionTypes";

const getCartItemId = (product) => {
    const vid = product.variationId;
    return vid ? `${product.id}_${vid}` : `${product.id}`;
};

const initialState = {
    items: [],
};

export const cartReducer = (state = initialState, action) => {
    switch (action.type) {
        case CART_ACTION_TYPES.ADD_ITEM: {
            const { product, quantity } = action.payload;
            const cartItemId = getCartItemId(product);

            const existingIndex = state.items.findIndex(item => item.cartItemId === cartItemId);

            if (existingIndex !== -1) {
                const newItems = [...state.items];
                newItems[existingIndex] = {
                    ...newItems[existingIndex],
                    quantity: newItems[existingIndex].quantity + quantity
                };
                return { ...state, items: newItems };
            } else {
                return {
                    ...state,
                    items: [...state.items, { ...product, cartItemId, quantity }]
                };
            }
        }

        case CART_ACTION_TYPES.UPDATE_QUANTITY: {
            const { cartItemId, quantity } = action.payload;

            return {
                ...state,
                items: state.items.map(item =>
                    item.cartItemId === cartItemId
                        ? { ...item, quantity: quantity }
                        : item
                )
            };
        }

        case CART_ACTION_TYPES.UPDATE_ITEM: {
            const { cartItemId, updates } = action.payload;
            const updatedProduct = { ...state.items.find(item => item.cartItemId === cartItemId), ...updates };
            const newCartItemId = getCartItemId(updatedProduct);

            return {
                ...state,
                items: state.items.map(item =>
                    item.cartItemId === cartItemId
                        ? { ...item, ...updates, cartItemId: newCartItemId }
                        : item
                )
            };
        }

        case CART_ACTION_TYPES.REMOVE_ITEM: {
            return {
                ...state,
                items: state.items.filter(item => item.cartItemId !== action.payload.cartItemId),
            };
        }

        case CART_ACTION_TYPES.CLEAR_CART: {
            return {
                ...state,
                items: [],
            };
        }

        default:
            return state;
    }
}